import { Slide } from 'yet-another-react-lightbox';
import { Lightbox, useLightBox } from '../lightbox';
import { SparkMediaDto } from '../../../../../libs/contracts/src/lib/common/media/media.dto';
import { FileTypeEnum } from '../../../../../libs/file-uploader/src/lib/enums/file-type.enum';
import { Gallery } from './gallery';

type Props = {
  media: SparkMediaDto[];
  variant?: 'grid' | 'list-grid' | 'single';
};

export const LightboxGallery = ({ media, variant = 'grid' }: Props) => {
  const slides: Slide[] =
    media?.map((media) => ({
      src: media.link,
      type: media.type,
      ...(media.type === FileTypeEnum.VIDEO && {
        poster: media.link,
        autoPlay: true,
        sources: [
          {
            src: media.link,
          },
        ],
      }),
    })) || [];
  const {
    selected: selectedImage,
    open: openLightbox,
    onOpen: handleOpenLightbox,
    onClose: handleCloseLightbox,
  } = useLightBox(slides);
  return (
    <>
      <Gallery
        media={media}
        onOpenLightbox={handleOpenLightbox}
        variant={variant}
      />
      <Lightbox
        index={selectedImage}
        slides={slides}
        open={openLightbox}
        close={handleCloseLightbox}
      />
    </>
  );
};
